export const SELF_ASSESSMENT_REQUEST = "SELF_ASSESSMENT_REQUEST";
export const SELF_ASSESSMENT_SUCCESS = "SELF_ASSESSMENT_SUCCESS";
export const SELF_ASSESSMENT_ERROR = "SELF_ASSESSMENT_ERROR";

export const CLEAR_SELF_ASSESSMENT_FLAG = "CLEAR_SELF_ASSESSMENT_FLAG";
